import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * V2 LiveStrip — Phase 1 stub (scraping required for live data).
 *
 * Black OS version polls the `check-live-backstage` Edge Function every 30s.
 * NoiRock Generic Phase 1 has no scraping infra yet — this stub renders a
 * minimal placeholder strip indicating Phase 2 status. When the scraping
 * pipeline is wired (Sprint 8+), replace this with a real LiveStrip that
 * reads from `live_sessions` table or an equivalent Edge Function.
 *
 * The strip is rendered only if `pages.manager.live` feature is active for
 * the tenant — otherwise the parent page hides it entirely.
 */
const LiveStripStub = () => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-between px-4 md:px-6 py-2.5 border-b border-accent/20 bg-accent/5">
      <div className="flex items-center gap-3 flex-wrap">
        <span className="flex items-center gap-1.5">
          <span className="inline-block w-2 h-2 rounded-full bg-accent/70" />
          <span className="text-[10px] uppercase tracking-[0.18em] font-bold text-accent">
            {t('adminV2.live.liveNow', 'LIVE NOW')}
          </span>
        </span>
        <span className="text-xs text-muted-foreground">
          {t('adminV2.live.stubMessage', 'Live data requires the scraping pipeline (Phase 2)')}
        </span>
      </div>
      <span className="text-[10px] uppercase tracking-widest text-muted-foreground/60 font-data">
        Phase 2
      </span>
    </div>
  );
};

export default LiveStripStub;
